const initialItems = [
    { id: 1, checked: false, item: "Milk" },
    { id: 2, checked: false, item: "Bread" },
    { id: 3, checked: false, item: "Eggs" }
];

export default initialItems;
